import {Service} from '@s-ui/domain'

/**
 * @class
 * @implements Service
 */
export default class GetPendingPtaCookieService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Repository} deps.repository
   */
  constructor({repository}) {
    super()
    this._repository = repository
  }

  /**
   * @return {Promise<Number>}
   */
  execute = () => this._repository.getPendingPta()
}
